﻿/**
 * @description Delivery Assurance module
 * @module DeliveryAssuranceModule
 * ----------------------------------------------------------------
*/

import { GroCommon } from './common';
import { setDropdown } from './form-controls'

/**
 * @description Create Readable Swedish date 2000-01-01
 * @param {Object} dateObject
 * @returns void
 */
const createReadableDate = (dateObject) => {
    let readableDate = `${ dateObject.getFullYear()
            }-${ String( dateObject.getMonth() + 1 ).padStart( 2, '0' )
            }-${ String( dateObject.getDate() ).padStart( 2, '0' )
            }`;
    return readableDate;
}

/**
 * @description Setting dates for Harvest period
 * @type {Date}
 * @type {boolean}
 * @returns void
 */
const deliverAssuranceFormPage = document.querySelector('.deliveryAssuranceForm') ? true : false;
let newDateObject = new Date();
let currentDate = createReadableDate(newDateObject);
let isHarvestPeriod = false;
let nightLoadingIsActivated = false;
let glyphosateIsActivated = false;

if (deliverAssuranceFormPage) {
    let newHarvestStartDate = new Date(`${document.querySelector('#harvestPeriodStart').value}`);
    let newHarvestEndDate = new Date(`${document.querySelector('#harvestPeriodEnd').value}`);
    let harvestStartDate = createReadableDate(newHarvestStartDate);
    let harvestEndDate = createReadableDate(newHarvestEndDate);
    isHarvestPeriod = (currentDate >= harvestStartDate && currentDate <= harvestEndDate) ? true : false;
    nightLoadingIsActivated = $('#nightLoadingIsActivated').val() === "1"  ? true : false;
    glyphosateIsActivated = $('#glyphosateIsActivated').val() === "1";
}

/**
 * @description Additional Harvest package update. 2022.
 * Facilities blocking Sludge grain
 * Check if Selected Warehouse value/Id is on the blocked facility list from Epi server.
 * @param {Object} wareHouseId
 * @returns void
 */
const checkBlockedSludgeFacilities = ( wareHouseId ) => {
    if ( BlockedSludgeFacilities.filter( x => x.Id === parseInt( wareHouseId ) ).length > 0 ) {
        document.querySelector( '.sludgePuppy-0' ).value = '';
        document.querySelector( '.sludgePuppy-1' ).click();
        document.querySelector( '.sludgePuppy-0' )
            .setAttribute( 'disabled', 'disabled' );
    } else {
        document.querySelector( '.sludgePuppy-0' )
            .removeAttribute( 'disabled', 'disabled' );
    }
};

/**
 * @description Additional Harvest package update. 2022.
 * Set Warning if a warehouse facility marked with 'z' is selected
 * @param {Object} warehouse
 * @returns void
 */
const warnZWareHouseSelected = ( warehouse ) => {
    if ( warehouse.target.innerText.slice( 0, 2 ) === 'z(' ) {
        document.querySelector( "#warehouseList" )
            .querySelector( "span.lm__warning-format" )
            .classList.remove( 'hidden' );
    } else {
        document.querySelector( "#warehouseList" )
            .querySelector( "span.lm__warning-format" )
            .classList.add( 'hidden' )
    }
}

/**
 * @descriptions Clear the radio buttons
 * @param {Object} buttons
 * @returns void
 */
const clearRadioButtons = (buttons) => {
    buttons.forEach(button => {
        button.classList.remove('clearRadioButton');
    });
}

/**
 * @description Check if the article is a Glyphosate article
 * By comparing list from EpiServer with the article id's.
 * We reset the Glyphosate radiobuttons and disable or not depending
 * on if article support glyphosate.
 * @returns void
 */
const glyphosateValidation = (articleValue) => {
    clearRadioButtons([document.querySelector( '#glyfpId_0' ), document.querySelector( '#glyfpId_1' )]);

    if ( GlyphosateArticles.filter( x => x.Id === parseInt( articleValue ) ).length > 0 ) {
        document.querySelector( '#glyfId_0' ).checked = false;
        document.querySelector( '#glyfId_0' ).removeAttribute( 'disabled', 'disabled' );
    } else {
        document.querySelector( '#glyfId_0' ).checked = false;
        document.querySelector( '#glyfpId_0' ).classList.add( 'clearRadioButton' );
        document.querySelector( '#glyfId_0' ).setAttribute( 'disabled', 'disabled' );
    }
}

/**
 * @description Initialize Glyphosate buttons on page load
 * Adding event listener and checking if Glyphosate is checked on load
 */
const initGlyphosate = () => {

    // Reset Glyphosate radiobuttons on click
    document.querySelector('#glyfId_0').addEventListener('click', function(event) {
        clearRadioButtons([document.querySelector( '#glyfpId_0' ), document.querySelector( '#glyfpId_1' )]);
    });

    document.querySelector('#glyfId_1').addEventListener('click', function(event) {
        clearRadioButtons([document.querySelector( '#glyfpId_0' ), document.querySelector( '#glyfpId_1' )]);
    });

    // Check if Glyphosate is checked on load
    if (document.querySelector( '#glyfId_0' ).getAttribute('checked') === 'checked') {
        document.querySelector( '#glyfId_0' ).click();
    }

    if (document.querySelector( '#glyfId_1' ).getAttribute('checked') === 'checked') {
        document.querySelector( '#glyfId_1' ).click();
    }
}

/**
 * @description Mutation Observer to listen to elementAttributes
 * Check if article is a copy of an old article otherwise add
 * mutationObserver on article input, so we know if any article changes.
 * If user change article, we run glyphosateValidation.
 * if article is a copy of an old article, we run glyphosateValidation.
 *
 * Logic kicks in if the current date is between the period startdate - enddate
 * Example period - 2023-10-15 - 2024-08-15
 * @returns void
 */
const checkForArticleChanges = () => {
    if (currentDate >= GlyphosateDatePeriod.start && currentDate <= GlyphosateDatePeriod.end) {
        const elementToObserve = document.getElementById( 'Article' );
        const articleValue = elementToObserve.getAttribute( 'value' );

        if (articleValue !== null && articleValue !== '') {
            glyphosateValidation(articleValue);
        } else {
            const observer = new MutationObserver( function ( mutationsList ) {
                for ( const mutation of mutationsList ) {
                    if ( mutation.type === 'attributes' && mutation.attributeName === 'value' ) {
                        const articleValueInMutation = mutation.target.getAttribute( 'value' );
                        glyphosateValidation(articleValueInMutation);
                    }
                }
            });

            const observerConfig = { attributes: true, attributeFilter: [ 'value' ] };
            observer.observe( elementToObserve, observerConfig );
        }

    } else {
        document.querySelector( '#glyfId_0' ).setAttribute( 'disabled', 'disabled' );
    }
}

/**
 * @description Update article label based on whether selected article has agreement (A)
 * Shows warning text if selected article doesn't include (A) in the name
 * @param {Object} article - Event object from click
 * @returns void
 */
const updateArticleLabelWarning = ( article ) => {
    if ( article.target.innerText.includes('(A)') ) {
        document.querySelector( "#articleFilter" )
            .querySelector( "span#article-agreement-warning" )
            .classList.add( 'hidden' );
    } else {
        document.querySelector( "#articleFilter" )
            .querySelector( "span#article-agreement-warning" )
            .classList.remove( 'hidden' )
    }
}

const resetWarehouseSelection = () => {
    var warehouseList = $('#warehouseList');

    // Clear the submitted warehouse value.
    warehouseList.find('input[name="Warehouse"]').val('');

    // Clear the visible warehouse field and its selected value.
    warehouseList.find('#a_Warehouse').val('').attr('data-value', '');

    // Clear the dropdown's selected value.
    warehouseList.find('.showcase').attr('data-value', '');

    // Clear the old warehouse options.
    warehouseList.find('.warehouseDropdown').html('');
};


$(function () {
    window.DeliveryAssuranceModule.init();

    // Sludge puppy && Glyphosate
    if(document.getElementsByClassName('deliveryAssuranceForm').length > 0) {
        // Check for sludge on load.
        checkBlockedSludgeFacilities(document.querySelector('#Warehouse').value);
        // Check Glyphosate articles
        checkForArticleChanges();
        // Initialize Glyphosate
        initGlyphosate();
    }
});

window.DeliveryAssuranceModule = window.DeliveryAssuranceModule || (function () {
    var reqDate, startDate, endDate, harvestPeriodStart, harvestPeriodEnd, existDepaAvtal;
    var agreementTypeIsConfirmed = false;
    var isInternal = 0;
    var enabledWarehouse = 0;
    var popupType = GroCommon.modalInfoClass;
    var firstTimeOpen = true;

    var getCalculateObject = function () {
        return {
            supplier: $('#dialog_CustomerNumber').val(),
            lorryType: $('#dialog_LorryType').val(),
            deliveryAddressId: $('#dialog_DeliveryAddress').val(),
            quantity: $('#dialog_Quantity').val(),
            deliveryDate: $('#dialog_DeliveryDate').val(),
            itemId: $('#dialog_Article').val(),
            isInternal: $('#IsInternal').val(),
            harvestYear: $('#dialog_HarvestYear').val()
        };
    };

    var setSelectedForCustomSelectBox = function (targeSelector, sourceSelector) {
        var selectedValue = $(sourceSelector).val();
        $(targeSelector).prev().find('li').each(function (index, item) {
            var matchValue = $(item).attr('data-value');
            if (matchValue === selectedValue) {
                $(item).find('a').trigger('click');
            }
        });
    };

    var fillCalculateForm = function () {
        $('#dialog_Quantity').val($('#Quantity').val());
        $('#dialog_DeliveryDate').val($('#DeliveryDate').val());
        setSelectedForCustomSelectBox('#dialog_LorryType', '#LorryType');
        setSelectedForCustomSelectBox('#dialog_DeliveryAddress', '#DeliveryAddress');
        setSelectedForCustomSelectBox('#dialog_Article', '#Article');
        setSelectedForCustomSelectBox('#dialog_HarvestYear', '#HarvestYear');
    };

    var confirmDialog = function (yesCallback, noCallback) {
        $('#confirmDelete').removeClass('hidden');
        $('#btnYes').unbind().click(function () {
            $('#confirmDelete').addClass('hidden');
            yesCallback();
        });
        $('#btnNo').unbind().click(function () {
            $('#confirmDelete').addClass('hidden');
            noCallback();
        });
    };

    var successDialog = function () {
        $('#deleteSuccess').removeClass('hidden');
    };

    var showInformationDialog = function (title, message, popupType) {
        var $dialog = $("#informationDialog");
        if (popupType) {
            $dialog.find('span.popup-type').addClass(GroCommon.getModalIconClass(popupType));
        }
        $dialog.find('#dialogTitle').html(title);
        $dialog.find('#dialogContent').html(message);
        $dialog.removeClass('hidden');
    };

    var showChangeNotAvailableDiglog = function () {
        $('#changeNotAvailable').removeClass('hidden');
    };

    var deleteDeliveryAssurance = function (self, totalSelector, ioNumber, lineNumber) {
        confirmDialog(function () {
            var loader = $(self).parents('.deliveryTableContainer').addClass('disabled').find('.loader-wrapper');
            loader.show();
            $.ajax({
                dataType: "json",
                type: 'post',
                url: '/api/delivery-assurance/delete',
                data: { ioNumber: ioNumber, lineNumber: lineNumber },
                cache: false,
                success: function (data) {
                    if (data.success) {
                        var total = parseInt($(totalSelector).val());
                        if (!isNaN(total) && total >= 1) {
                            total = total - 1;
                            $(totalSelector).val(total);
                        }
                        $(self).parents('tr').remove();
                        successDialog();
                    } else {
                        showInformationDialog('', data.message, popupType.error);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    showInformationDialog('', errorThrown.toString(), popupType.error);
                },
                complete: function (jqXHR) {
                    loader.hide().parents('.deliveryTableContainer').removeClass('disabled');
                }
            });
        }, function () {

        });
    };

    var printMultiLines = function (cbxClassName) {
        var ioNumbers = "";
        var lineNumbers = "";
        var rowSelected = 0;

        $('.' + cbxClassName).each(function () {
            if ($(this).is(':checked')) {
                rowSelected++;
                // Get the value. Value contains of string with this format "IOnumber;lineNumber".
                var cbxValue = $(this).val();

                if (cbxValue) {
                    var valSplit = cbxValue.split(';');
                    if (valSplit != null) {

                        ioNumbers += valSplit[0] + "|";
                        lineNumbers += valSplit[1] + "|";
                    }
                }
            }
        });

        if (rowSelected === 0) {
            alert("Du måste först välja rader");
            return;
        }
        // Remove the last pipe line |
        if (ioNumbers !== "")
            ioNumbers = ioNumbers.slice(0, -1);

        if (lineNumbers !== "")
            lineNumbers = lineNumbers.slice(0, -1);

        // Create link to pdfHandler.
        var hrefLink = "/api/pdfhandler/generatemultipdf?ioNumber={ioNumber}&lineNumber={lineNumber}&resync=true";

        hrefLink = hrefLink.replace("{ioNumber}", ioNumbers); //ex: ioNumbers = "4022316|4023510"
        hrefLink = hrefLink.replace("{lineNumber}", lineNumbers); // ex: lineNumber =  "3|5"

        // Invoke now pdfHandler to create the pdf file.
        window.open(hrefLink, '_blank');
    };

    var getWarehouseList = function (deliveryDateSelector, sort) {
        $.ajax({
            dataType: "json",
            type: 'post',
            url: '/api/delivery-assurance/get-warehouse',
            data: {
                action: $('#Action').val(),
                customerNumber: $('#dialog_CustomerNumber').val(),
                sort: sort,
                deliveryDateStr: $(deliveryDateSelector).val(),
            },
            cache: false,
            success: function (data) {
                agreementTypeIsConfirmed = false;
                if (data.warehouses) {
                    $('.warehouseDropdown').html('');
                    $.each(data.warehouses, function (index, item) {
                        $('.warehouseDropdown')
                            .append('<li data-value="' + item.Key + '"><a href="javascript:void(0)">' + item.Value + '</a></li>');
                    });

                    setDropdown($('.warehouseDropdown').parents('ul.lm__form-dropdown'), 'type-3');

                    $('#warehouseList').find(".showcase .dropdown li a").click(function (evt) {
                        var inputElement = $(this).parents(".showcase").find("input.form-element");
                        var inputSelector = inputElement.attr('id');
                        $("#deliveryAssuranceForm").validate().element('#' + inputSelector);

                        // Additional Harvest package update. 2022.
                        warnZWareHouseSelected(evt);
                        checkBlockedSludgeFacilities($(this).parent("li").attr('data-value'));
                    });
                }

                $('.depaAvtalsDropDown').html('');
                if (data.depaAvtals && data.depaAvtals.length > 1) {
                    $('input[name="DeliveryType"]:radio').each(function (index, item) {
                        var value = $(item).val();
                        if (value === "Depa") {
                            $(item).prop('disabled', false);
                        }
                    });
                    existDepaAvtal = 1;

                    $.each(data.depaAvtals, function (index, item) {
                        $('.depaAvtalsDropDown')
                            .append('<li data-value="' + item.Key + '"><a href="javascript:void(0)">' + item.Value + '</a></li>');
                    });

                    setDropdown($('.depaAvtalsDropDown').parents('ul.lm__form-dropdown'), 'type-3');

                    $('#depaAvtal').find(".showcase .dropdown li a").click(function () {
                        var inputElement = $(this).parents(".showcase").find("input.form-element");
                        var inputSelector = inputElement.attr('id');
                        $("#deliveryAssuranceForm").validate().element('#' + inputSelector);
                    });
                }
                else {
                    $('input[name="DeliveryType"]:radio').each(function (index, item) {
                        var value = $(item).val();
                        if (value === "Depa" && $("#Article").val() != "") {
                            $(item).prop('disabled', true);
                            $('#depaAvtal').addClass('hidden');
                        }
                    });
                    existDepaAvtal = 0;
                }

            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (errorThrown.message && errorThrown.message === "Unexpected token < in JSON at position 0") {
                    window.location.href = "/";
                }
                else {
                    showInformationDialog('', errorThrown.toString(), popupType.error);
                }
            },
            complete: function (jqXHR) {
            }
        });
    };

    var validateDeliveryAssurance = function () {
        if ($().validate && $("#deliveryAssuranceForm").length) {
            $("#deliveryAssuranceForm").validate({
                ignore: [],
                errorElementClass: 'error',
                errorClass: 'error-item',
                errorElement: 'span',
                rules: {
                    Quantity: {
                        required: true,
                        max: 39,
                        min: 1
                    },
                    Torkat: {
                        required: true
                    },
                    Red: {
                        required: true
                    },
                    Straforkortat: {
                        required: true
                    },
                    Glyfosat: {
                        required: glyphosateIsActivated
                    },
                    Slam: {
                        required: true
                    },
                    HarvestYear: {
                        required: true
                    },
                    DeliveryType: {
                        required: true
                    },
                    DeliveryAddress: {
                        required: true
                    },
                    Transportation: {
                        required: true
                    },
                    DeliveryDate: {
                        required: true,
                        date: true
                    },
                    DepaAvtal: {
                        required: function (element) {
                            return $('input[name="DeliveryType"]:checked').val() === "Depa";
                        }
                    },
                    Article: {
                        required: true
                    },
                    Warehouse: {
                        required: function (element) {
                            return enabledWarehouse == "1" && !$('#warehouseList').hasClass('hidden') && !$('#Transportation_Farm').is(':checked');
                        }
                    },
                    LorryType: {
                        required: function (element) {
                            return $('#Transportation_Farm:checked').length === 1;
                        }
                    },
                    NightLoading: {
                        required: function (element) {
                            if (deliverAssuranceFormPage && nightLoadingIsActivated) {
                                return $('#Transportation_Farm:checked').length === 1;
                            } else {
                                return false;
                            }

                        }
                    },
                    LoadingHeight: {
                        required: function (element) {
                            if (deliverAssuranceFormPage && isHarvestPeriod) {
                                return $('#Transportation_Farm:checked').length === 1;
                            } else {
                                return false;
                            }
                        }
                    }
                },
                messages: {
                    Quantity: {
                        required: "Du måste ange Kvantitet (ton)",
                        max: "Vänligen ange ett värde mellan 1 och 39",
                        min: "Vänligen ange ett värde mellan 1 och 39"
                    },
                    Torkat: {
                        required: "Du måste ange Varmluftstorkat"
                    },
                    Red: {
                        required: "Du måste ange RED"
                    },
                    Straforkortat: {
                        required: "Du måste ange Stråförkortning"
                    },
                    Glyfosat: {
                        required: "Du måste ange Glyfosat"
                    },
                    NightLoading: {
                        required: "Du måste ange ja eller nej"
                    },
                    LoadingHeight: {
                        required: "Du måste ange ja eller nej"
                    },
                    Slam: {
                        required: "Du måste ange Slammat"
                    },
                    HarvestYear: {
                        required: "Du måste ange Skördeår"
                    },
                    DeliveryType: {
                        required: "Du måste ange Överleverans"
                    },
                    DeliveryAddress: {
                        required: "Du måste ange Leveransadress"
                    },
                    DeliveryDate: {
                        required: "Du måste ange Leveransdatum",
                        date: "Var vänlig ange ett giltigt datum"
                    },
                    DepaAvtal: {
                        required: "Inget depåavtal valt. Om vald leveranstyp är Depåavtal behöver ett depåavtal också väljas från listan."
                    },
                    Article: {
                        required: "Du måste ange Artikel"
                    },
                    Transportation: {
                        required: "Du måste ange Transportsätt"
                    },
                    Warehouse: {
                        required: "Du måste ange Mottagningsplats"
                    },
                    LorryType: {
                        required: "Du måste ange Leveranssätt"
                    }
                },
                highlight: function (element, errorClass, validClass) {
                    $('li#p_' + $(element).attr('name')).show();
                    var errors = $('ul.errors-list li').filter(function () { return $(this).css('display') === 'list-item'; }).length;
                    if (errors >= 3) {
                        $('ul.errors-list').show();
                    }
                    $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
                    $('li#p_' + $(element).attr('name')).hide();
                    var errors = $('ul.errors-list li').filter(function () { return $(this).css('display') === 'list-item'; }).length;
                    if ($('ul.errors-list').find('li[id^="p"]').is(":visible") === false || errors < 3) {
                        $('ul.errors-list').hide();
                    }
                },
                errorPlacement: function (error, element) {
                    var typeElement = $(element).attr('type');
                    if (typeElement === 'radio') {
                        element.parent('div.lm__radio').parent().before(error);
                    } else {
                        element.after(error);
                    }
                },
                submitHandler: function (form) {

                    $('.loader-wrapper').show();
                    $("#btnSubmitDelivery").addClass('disabled');

                    var sponIsSelected = $('input[name="DeliveryType"][value="Spon"]:radio:checked').size() == 1 ? true : false;
                    var ignoreDepaAvtal = (existDepaAvtal === 1 && sponIsSelected);
                    var confirmationIsRequired = (ignoreDepaAvtal && !agreementTypeIsConfirmed);
                    if (confirmationIsRequired) {
                        $("#confirmDuplicateAgreementBtn").one("click", function (event) {
                            $("#confirmDuplicationModal").addClass("hidden");
                            $('#btnSubmitDelivery').addClass('reverse-state').removeClass('disabled');
                            $('.loader-wrapper').hide();
                            agreementTypeIsConfirmed = true;
                        });
                        $("#confirmDuplicateAgreementCloseBtn").one("click", function (event) {
                            $("#confirmDuplicationModal").addClass("hidden");
                            $('#btnSubmitDelivery').addClass('reverse-state').removeClass('disabled');
                            $('.loader-wrapper').hide();
                            agreementTypeIsConfirmed = true;
                        });
                        $("#confirmDuplicationModal").removeClass("hidden");
                        $('.loader-wrapper').hide();
                        $('#btnSubmitDelivery').addClass('reverse-state').removeClass('disabled');
                        agreementTypeIsConfirmed = false;
                    }
                    else {
                        form.submit();
                    }
                }
            });
        }

        if ($().validate && $("#deliveryAssuranceFormStep2").length) {
            $("#deliveryAssuranceFormStep2").validate({
                ignore: [],
                errorElementClass: 'error',
                errorClass: 'error-item',
                errorElement: 'span',
                rules: {
                    noOfNew: {
                        required: function () {
                            return $('input[name="createNew"]:checked').val() === "1";
                        },
                        digits: true,
                        min: 1,
                        max: 100
                    }
                },
                messages: {
                    noOfNew: {
                        required: "Du måste ange en siffra",
                        digits: "Ange endast siffror",
                        min: "Värdet måste vara minst 1",
                        max: "Max antal är 100"
                    }
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                submitHandler: (form) => {
                    $(".loader-wrapper").show();
                    $("#btnSubmitDeliveryFinal").addClass('disabled');
                    form.submit();
                }
            });
        }

        if ($().validate && $("#calculateFormDialog").length) {
            $("#calculateFormDialog").validate({
                ignore: [],
                errorElementClass: 'error',
                errorClass: 'error-item',
                errorElement: 'span',
                rules: {
                    dialog_LorryType: "required",
                    dialog_DeliveryAddress: {
                        required: true
                    },
                    dialog_Quantity: {
                        required: true,
                        number: true,
                        min: 1
                    },
                    dialog_DeliveryDate: {
                        required: true,
                        swedishDate: true
                    },
                    dialog_Article: {
                        required: true
                    },
                    dialog_HarvestYear: {
                        required: true
                    }
                },
                messages: {
                    dialog_LorryType: {
                        required: "Du måste välja leveranssätt"
                    },
                    dialog_DeliveryAddress: {
                        required: "Du måste välja en leveransadress"
                    },
                    dialog_Quantity: {
                        required: "Du måste ange en kvantitet större än 0",
                        number: "Ange ett numeriskt värde",
                        min: "Du måste ange en kvantitet större än 1"
                    },
                    dialog_DeliveryDate: {
                        required: "Du måste ange ett giltigt datum",
                        swedishDate: "Du måste ange ett giltigt datum"
                    },
                    dialog_Article: {
                        required: "Du måste välja en artikel"
                    },
                    dialog_HarvestYear: {
                        required: "Du måste välja ett skördeår"
                    }
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
                    if ($(element.previousElementSibling).hasClass("dropdown") && !firstTimeOpen) {
                        $(element).siblings("a").addClass("error");
                    }
                    firstTimeOpen = false;
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
                    if ($(element.previousElementSibling).hasClass("dropdown")) {
                        $(element).siblings("a").removeClass("error");
                    }
                }
            });
        }
    };

    var initEvent = function () {
        if (deliverAssuranceFormPage && isHarvestPeriod) {
            if ($('#Transportation_Farm').is(':checked')) {
                $('.loadHeight-container').removeClass('hidden');
            } else {
                $('.loadingHeight').prop('checked',false);
            }
        }

        if (deliverAssuranceFormPage && nightLoadingIsActivated) {
            if ($('#Transportation_Farm').is(':checked')) {
                $('.nightLoading-container').removeClass('hidden');
            }
        }

        if (glyphosateIsActivated) {
            $('.glyphosate-container').removeClass('hidden');
        }

        $('#Transportation_Farm').change(function () {
            if (deliverAssuranceFormPage && isHarvestPeriod) {
                $(".loadingHeight").prop('checked',false);
            }

            if ($(this).is(':checked')) {
                $('.js-transportation-terms-and-conditions:radio').prop('checked', false);
                $('#lorryType').removeClass('hidden');
                if (isInternal != "1") {
                    $('#warehouseList').addClass('hidden');
                }
                if (deliverAssuranceFormPage && isHarvestPeriod) {
                    $('.loadHeight-container').removeClass('hidden');
                    if(!$(".loadingHeight").is(':checked')) {
                        $('#LoadingHeight-1').click();
                    }
                }

                if (deliverAssuranceFormPage && nightLoadingIsActivated) {
                    $('.nightLoading-container').removeClass('hidden');
                    if(!$(".nightLoading").is(':checked')) {
                        // #NightLoading-1 is equal to "no" in UI
                        $('#NightLoading-1').click();
                    }
                }

                $("#deliveryAssuranceForm").validate().element("#Warehouse");
                $("#deliveryAssuranceForm").validate().element("#DeliveryDate");
            }
        });

        $('.js-transportation-terms-and-conditions:radio').change(function () {
            if ($(this).is(':checked')) {
                if (deliverAssuranceFormPage && isHarvestPeriod) {
                    $('.loadHeight').addClass('hidden');
                    $('#LoadingHeight-1').click();
                    $('#LoadingHeight-1').removeAttr('checked');
                }

                if (deliverAssuranceFormPage && nightLoadingIsActivated) {
                    $('.nightLoading-container').addClass('hidden');
                    $('#NightLoading-1').click();
                    $('#NightLoading-1').removeAttr('checked');
                }

                $('#Transportation_Farm').prop('checked', false);
                $('#a_LorryType').html('Välj transportsätt');
                $('#LorryType').val('');
                $('#lorryType').addClass('hidden');
                if (isInternal != "1") {
                    $('#warehouseList').removeClass('hidden');
                }
                $("#deliveryAssuranceForm").validate().element('#Transportation_Farm');
                $("#deliveryAssuranceForm").validate().element("#DeliveryDate");
                $("#deliveryAssuranceForm").validate().element("#Warehouse");
            }
        });

        $('input[name="DeliveryType"]:radio').change(function () {
            var value = $('input[name="DeliveryType"]:checked').val();
            if (value === "Depa") {
                $('#depaAvtal').removeClass('hidden');
            } else if (value === "Spon") {
                $('#depaAvtal').addClass('hidden');
            }
        });

        $('input[name="createNew"]:checkbox').change(function () {
            $('#noOfNew').val('');
            if ($(this).is(':checked')) {
                $('#noOfNew').parent().show();
            } else {
                $('#noOfNew').parent().hide();
                $('#createPdf').prop('disabled', false);
            }
        });

        $('#approveTerm').change(function () {
            if ($(this).is(':checked')) {
                $('#btnSubmitDelivery').addClass('reverse-state').removeClass('disabled');
            } else {
                $('#btnSubmitDelivery').addClass('disabled').removeClass('reverse-state');
            }
        });

        $('.cbxApproveDelAss').change(function () {
            if ($('.cbxApproveDelAss').is(':checked')) {
                $('#btnApprove').addClass('reverse-state').removeClass('disabled');
            } else {
                $('#btnApprove').addClass('disabled').removeClass('reverse-state');
            }
        });

        $('.cbxToPrintDeliveried').change(function () {
            if ($('.cbxToPrintDeliveried').is(':checked')) {
                $('#btnToPrintDeliveried').removeClass('disabled');
            } else {
                $('#btnToPrintDeliveried').addClass('disabled');
            }
        });

        $('.cbxToPrintConfirmed').change(function () {
            if ($('.cbxToPrintConfirmed').is(':checked')) {
                $('#btnToPrintConfirmed').removeClass('disabled');
            } else {
                $('#btnToPrintConfirmed').addClass('disabled');
            }
        });

        $('#noOfNew').blur(function () {
            var noOfNew = parseInt($(this).val());
            if (!isNaN(noOfNew) && noOfNew > 0) {
                var cb = $('#createPdf');
                cb.prop('checked', false);
                cb.prop('disabled', true);
            }
        });

        $('#openCalculateFee').click(function () {
            fillCalculateForm();
            $("#calculateFormDialog").validate().resetForm();
            $('#calculateFeeDialog').removeClass('hidden');
            $('#calculateFeeDialog input#dialog_Quantity').removeClass('error');
            $('#calculateResult').html('');
            // increase z-index for datetime-picker
            $("#ui-datepicker-div").css({ zIndex: 9999 });
        });

        $('#calculateFree').click(function () {
            if (!$("#calculateFormDialog").valid()) {
                return;
            }
            var calculateObject = getCalculateObject();
            $('#calculateFeeDialog').find('.loader-wrapper').show();
            $.ajax({
                url: '/api/deliveryfee/calculate',
                type: 'POST',
                data: {
                    supplier: calculateObject.supplier,
                    lorryType: calculateObject.lorryType,
                    deliveryAddressId: calculateObject.deliveryAddressId,
                    quantity: calculateObject.quantity,
                    deliveryDate: calculateObject.deliveryDate,
                    itemId: calculateObject.itemId,
                    isInternal: (calculateObject.isInternal == "1" ? "true" : "false"),
                    HarvestYear: calculateObject.harvestYear

                },
                success: function (data) {
                    $('#calculateResult').html(data);
                },
                complete: function (jqXHR) {
                    $('#calculateFeeDialog').find('.loader-wrapper').hide();
                }
            });
        });

        $('#clearBtn').click(function () {
            //clear delivery address
            $('#a_deliveryAddress').html('Välj leveransadress');
            $('#DeliveryAddress').val('');
            //clear date
            $('#DeliveryDate').val('');
            //clear article
            $('#a_article').html('Välj artikel');
            $('#Article').val('');
            //clear quantity
            $("#Quantity").val('');
            //clear year
            $('#a_HarvestYear').html('');
            $('#HarvestYear').val('');
            //clear Mottagningsplats
            $('#a_Warehouse').html('Välj mottagningsplats');
            $('#Warehouse').val('');
            $('.warehouseDropdown').html('');
            //clear Leveranssätt
            $('#a_LorryType').html('Välj transportsätt');
            $('#LorryType').val('');

            //clear delivery type
            $('input[name="DeliveryType"]').prop('checked', false);
            //clear Varmluftstorkat
            $("input[name='Torkat']").prop('checked', false);
            //clear RED
            $("input[name='Red']").prop('checked', false);
            //clear Straforkortat
            $("input[name='Straforkortat']").prop('checked', false);
            //clear Glyfosat
            $("input[name='Glyfosat']").prop('checked', false);
            //clear Slam
            $("input[name='Slam']").prop('checked', false);

            $(".js-transportation-terms-and-conditions").prop('checked', false);
            $('#Transportation_Farm').prop('checked', false);

            $("textarea[name='OtherInfo']").val("");

            $("#deliveryAssuranceForm").validate().resetForm();
            //$('#btnSubmitDelivery').addClass('disabled').removeClass('reverse-state');
            $('#depaAvtal').addClass('hidden');
            $('#lorryType').addClass('hidden');
            if (isInternal != "1") {
                $('#warehouseList').addClass('hidden');
            }
        });

        $('#deliveryAssuranceForm').find(".showcase .dropdown li a").click(function (evt) {
            var inputElement = $(this).parents(".showcase").find("input.form-element");
            var inputSelector = inputElement.attr('id');
            $("#deliveryAssuranceForm").validate().element('#' + inputSelector);

            // Update article warning if this is an article selection
            if (inputSelector === 'Article') {
                updateArticleLabelWarning(evt);
                resetWarehouseSelection();
            }
        });

        $('#calculateFormDialog').find(".showcase .dropdown li a").click(function () {
            var inputElement = $(this).parents(".showcase").find("input.form-element");
            var inputSelector = inputElement.attr('id');
            $("#calculateFormDialog").validate().element('#' + inputSelector);
        });
    };

    var initVar = function () {
        var preDaysDelivery = parseInt($('#preDaysDelivery').val());
        var postDaysDelivery = parseInt($('#postDaysDelivery').val());
        if (isNaN(preDaysDelivery) || isNaN(postDaysDelivery)) return;

        reqDate = GroCommon.dateFromISO($('#reqDate').val());
        startDate = GroCommon.dateFromISO($('#reqDate').val());
        startDate.setHours(0, 0, 0, 0);
        startDate.setDate(reqDate.getDate() + preDaysDelivery);

        endDate = GroCommon.dateFromISO($('#reqDate').val());
        endDate.setHours(23, 59, 59, 999);
        endDate.setDate(reqDate.getDate() + postDaysDelivery);

        harvestPeriodStart = GroCommon.dateFromISO($('#harvestPeriodStart').val());
        harvestPeriodEnd = GroCommon.dateFromISO($('#harvestPeriodEnd').val());
        isInternal = $('#IsInternal').val();
        enabledWarehouse = $('#EnabledWarehouse').val();

        var numberOfDepaAvtal = parseInt($('#numberOfDepaAvtal').val());
        if (!isNaN(preDaysDelivery)) {
            if (numberOfDepaAvtal > 1) {
                existDepaAvtal = 1;
                $('input[name="DeliveryType"]:radio').each(function (index, item) {
                    var value = $(item).val();
                    if (value === "Depa") {
                        $('#depaAvtal').removeClass('hidden');
                    }
                });
            } else {
                if ($("#Article").size() === 1 && $("#Article").val() != "") {
                    getWarehouseList("#DeliveryDate", $("#Article").val());
                }
                existDepaAvtal = 0;
            }
        }

        $('#deliveryAssuranceForm .dropdown li.selected, #calculateFeeDialog .dropdown li.selected').each(function (index, item) {
            var description = $(item).find('a').html();
            $(item).parent('ul').prev('a').html(description);
        });
    };

    var initDeliveryDate = function () {
        if ($.fn.datepicker && $(".delivery-datepicker").length) {
            $(".delivery-datepicker").datepicker({
                defaultDate: new Date(),
                dateFormat: "yy-mm-dd",
                beforeShow: function (input, inst) {
                    inst.dpDiv
                        .removeClass("delivery-datepicker-div")
                        .addClass("delivery-datepicker-div");
                },
                onClose: function (dateText, inst) {
                    inst.dpDiv.removeClass("delivery-datepicker-div");
                },
                onSelect: function (newText) {
                    // compare the new value to the previous one
                    if ($(this).data('previous') !== newText) {
                        if ($("#deliveryAssuranceForm").validate().element("#DeliveryDate")) {
                            getWarehouseList(this, $("#Article").val());
                        }
                    }
                },
                monthNames: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
                dayNamesMin: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
                firstDay: 1,
            })
                .on('change', function () {
                    var $this = $(this);
                    var validDate = !/Invalid|NaN/.test(new Date($this.val()).toString());
                    var validDateRegex = /^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])$/ig.test($this.val());

                    $("#deliveryAssuranceForm").validate().element("#DeliveryDate");

                    if (!validDateRegex || !validDate) {
                        //$this.addClass("error").next().show();
                        //$this.next().show();
                    } else {
                        //$this.removeClass("error").next().hide();
                        //$this.next().hide();
                        getWarehouseList(this, $("#Article").val());
                    }

                });
        }
    };

    var addValidation = function () {
        if ($.validator) {
            $.validator.addMethod("dateHigherThanToday", function (value, element) {
                //If false, the validation fails and the message below is displayed
                var currentDate = new Date();

                var valGardshamtning = $('#Transportation_Farm:checked').val();
                if (valGardshamtning === '1') {
                    if (!element)
                        return false;

                    var selectedDate = GroCommon.dateFromISO(element.value);  // new Date(element.value); funkar bara med IE9+

                    selectedDate.setHours(0, 0, 0, 0);

                    var currentHours = currentDate.getHours();
                    currentDate.setHours(0, 0, 0, 0);

                    if (selectedDate < currentDate)
                        return false;

                    if ((selectedDate.getFullYear() === currentDate.getFullYear()) &&
                        (selectedDate.getMonth() === currentDate.getMonth()) &&
                        (selectedDate.getDate() === currentDate.getDate()) && (currentHours > 9))
                        return false;

                }
                return true;
            }, "Leveransdatum kan inte vara dagens datum eller tidigare.");

            if (startDate && reqDate) {
                $.validator.addMethod('dateHarvest206', function (value, element) {
                    if (this.optional(element)) {
                        return true;
                    }
                    var enteredDate = GroCommon.dateFromISO(element.value);
                    var tomorrow = new Date();
                    tomorrow.setDate(new Date().getDate() + 1);

                    return ((tomorrow <= enteredDate) && (enteredDate <= reqDate));

                }, $.validator.format("Vänligen ange ett datum mellan {0} och {1}.", startDate ? startDate.toShortDateString() : "", reqDate ? reqDate.toShortDateString() : ""));
            }

            if (harvestPeriodStart && harvestPeriodEnd) {
                $.validator.addMethod('dateHarvestRange', function (value, element) {
                    if (this.optional(element)) {
                        return true;
                    }

                    var enteredDate = GroCommon.dateFromISO(element.value);

                    return ((enteredDate >= harvestPeriodStart) && (enteredDate <= harvestPeriodEnd));

                }, $.validator.format("Vänligen ange ett datum inom skördeperioden, dvs {0}/{1} - {2}/{3}.",
                    harvestPeriodStart.getDate().toString(),
                    (harvestPeriodStart.getMonth() + 1).toString(),
                    harvestPeriodEnd.getDate().toString(),
                    (harvestPeriodEnd.getMonth() + 1).toString()));
            }

            if (startDate && endDate) {
                $.validator.addMethod('daterange', function (value, element) {
                    if (this.optional(element)) {
                        return true;
                    }
                    var enteredDate = GroCommon.dateFromISO(element.value);

                    return ((startDate <= enteredDate) && (enteredDate <= endDate));

                }, $.validator.format("Vänligen ange ett datum mellan {0} och {1}.", startDate ? startDate.toShortDateString() : '', endDate ? endDate.toShortDateString() : ''));
            }
        }
    };

    var init = function () {
        initDeliveryDate();
        initVar();
        initEvent();
        addValidation();
        validateDeliveryAssurance();
    };

    return {
        init: init,
        deleteDeliveryAssurance: deleteDeliveryAssurance,
        showChangeNotAvailableDiglog: showChangeNotAvailableDiglog,
        printMultiLines: printMultiLines,
        getWarehouseList: getWarehouseList,
        confirmDialog: confirmDialog
    };
})();

export default window.DeliveryAssuranceModule;
